<template>
  <div class="terms-conditions container-custom">
    <div class="terms-conditions__header">
      <div class="terms-conditions__header__title">
        TERMS AND CONDITIONS
      </div>
      <div class="terms-conditions__header__des">
        Numbers Betting
      </div>
    </div>
    <div class="terms-conditions__description">
      <p class="terms-conditions__description__item">
        The following shall apply to Numbers Betting:
      </p>
      <p class="terms-conditions__description__item">
        Numbers betting results are sourced from real-world lotteries and all numbers wagers are based on the numbers resulted from the Lucky Numbers game selected by the player.
      </p>
      <p class="terms-conditions__description__item">
        Each Lucky Numbers draw offers a variety of the following fixed odds markets:
      </p>
    </div>
    <div class="terms-conditions__content">
      <table class="table table-striped">
        <thead>
        <tr class="terms-conditions__content__title">
          <th scope="col">#</th>
          <th scope="col">Market Type</th>
          <th scope="col">Description</th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(item, key) in termsConditions"
            :key="key"
        >
          <th scope="row">{{ item.id }}</th>
          <td class="terms-conditions__content__table-text">{{ item.type }}</td>
          <td class="terms-conditions__content__table-text">{{ item.description }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="terms-conditions__description">
      <p class="terms-conditions__description__item">
        All numbers bets for a specific draw must be placed and confirmed before the draw cutoff, as well as before the first number is drawn for the wagered bet.
      </p>
      <p class="terms-conditions__description__item">
        If for any reason a bet is placed after the first number is drawn, the wagers will be voided and the full stake will be refunded.
      </p>
      <p class="terms-conditions__description__item">
        If a draw time is re-scheduled, the draw will be cancelled, and all affected wagers will be refunded. A new draw may be introduced with the re-scheduled time slot.
      </p>
      <p class="terms-conditions__description__item">
        Numbers draw shall be resulted in accordance with the first result obtained from the official Lucky Numbers website. If any mistakes and/or alternative submissions are published, the draw will be cancelled and all wagers will be refunded.
      </p>
      <p class="terms-conditions__description__item">
        All wagers that cannot be settled for any reason will be voided and refunded.
      </p>
      <p class="terms-conditions__description__item">
        All numbers betting markets are fixed odds bets, with one outcome, a win or a loss. No consolation prizes are offered for any draws and/or markets. All of the selected numbers drawn must match the wager entry in any order or must match the wagered market and must have resulted correctly for the bet to win.
      </p>
      <p class="terms-conditions__description__item">
        In standard bet markets, all the numbers selected for a wager must be drawn in order for it to be a winning bet. As an example, if four numbers are selected (Market 4 Numbers) at the odds of 2275/1 and three of those four selected numbers are drawn, there is no win and no payout.
      </p>
      <p class="terms-conditions__description__item">
        For a successful wager, the player must select a market type, select the numbers or expected market outcome for a draw, choose the wager stake and make the bet before the Lucky Numbers draw has its first ball drawn or the cutoff countdown has expired, after which the results must be published correctly. Following the publishing of valid Lucky Numbers results, all wager payouts will be paid directly to the player account wallet.
      </p>
      <p class="terms-conditions__description__item">
        If any of the draws expire before the wager is finalized, these wagers may be moved to the next available draw by the player or they can be cancelled.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      termsConditions: [
        {
          id: 1,
          type: 'The sum of balls drawn will be odd or even',
          description: 'The sum of the regular balls drawn will be odd or even.'
        },
        {
          id: 2,
          type: 'The sum of balls drawn will be over or under',
          description: 'The sum of the regular balls drawn will be over or under the set boundary.'
        },
        {
          id: 3,
          type: 'The sum of the regular balls drawn will be within a specified range',
          description: 'There are fourteen different ranges within which the player may predict the winning total.'
        },
        {
          id: 4,
          type: 'The bonus ball drawn will be odd or even',
          description: 'The player wagers whether the bonus ball drawn will be odd or even. This bet option is only available for lotteries with one bonus ball.'
        },
        {
          id: 5,
          type: 'The sum of the bonus balls drawn will be odd or even',
          description: 'The player wagers whether the sum of the bonus balls drawn will be odd or even. This bet option is only available for lotteries with two bonus balls.'
        },
        {
          id: 6,
          type: 'The bonus ball drawn will be over or under',
          description: 'The player wagers whether the bonus ball will be over or under the set boundary. This bet option is only available for lotteries with one bonus ball.'
        },
        {
          id: 7,
          type: 'The sum of the bonus balls drawn will be over or under',
          description: 'The player wagers whether the sum of the bonus balls drawn will be over or under the set boundary. This bet option is only available for Lucky Numbers games with two bonus balls.'
        },
        {
          id: 8,
          type: 'The bonus ball drawn will be a single digit number',
          description: 'The player wagers whether the bonus ball will be a single digit number. In Lucky Numbers games with two bonus balls, at least one bonus ball needs to be a single digit for the player to claim the winning. This market is not available for the draw types where there are only single digit numbers in the bonus ball draw.'
        },
        {
          id: 9,
          type: 'The bonus ball drawn will be the same number as one of the regular balls drawn',
          description: 'The player wagers whether the bonus ball will be the same number as one of the balls in the regular draw. In the case where two bonus balls are drawn from the additional drum, the player claims the winning if either of the bonus balls drawn is equal to any ball drawn in the regular draw.'
        },
        {
          id: 10,
          type: 'The sum of the bonus balls drawn will be within a specified range',
          description: 'The player wagers whether the bonus ball drawn will be within one of the 5 ranges offered. This bet option is only available for Lucky Numbers games with one bonus ball.'
        },
        {
          id: 11,
          type: 'The sum of the regular balls and the bonus balls will be over or under',
          description: 'The player wagers whether the sum of the numbers drawn including the bonus ball will be over or under the set boundary.'
        },
        {
          id: 12,
          type: 'Standard bet (without bonus ball)',
          description: 'Depending on the type of the Lucky Numbers game, players select numbers that they believe will be drawn; in order to claim the winning the player must predict all drawn numbers. All numbers selected in one bet must be drawn, except the bonus ball, in order for it to be a winning bet.'
        },
        {
          id: 13,
          type: 'Standard bet (incl. bonus ball in the same drum)',
          description: 'The players select numbers based on the rules of the Standard bet, but the probability of winning is increased as the hit of the bonus ball will count as well. All numbers selected in one bet must be drawn in order for it to be a winning bet.'
        },
        {
          id: 14,
          type: 'Standard bet (incl. bonus ball from the additional drum)',
          description: 'The players choose numbers based on the rules of the Standard bet, but the probability of winning is increased as the hit of the bonus ball will count as well. In the case where there are two bonus balls drawn, the player must match the numbers selected from the regular draw, and one of the bonus balls to claim the winning. All numbers selected in one bet must be drawn in order for it to be a winning bet.'
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/terms-conditions/terms-conditions.scss"/>
